import { Link } from 'react-router-dom';
import logo from '@/assets/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const columns = [
    {
      title: 'Versicherungen',
      titleHref: '/versicherungen',
      links: [
        { label: 'Krankenversicherung', href: '/versicherungen/krankenversicherung' },
        { label: 'Berufsunfähigkeit', href: '/versicherungen/berufsunfaehigkeit' },
        { label: 'Haftpflicht', href: '/versicherungen/haftpflicht' },
        { label: 'Weitere Versicherungen', href: '/versicherungen/sonstige' },
      ],
    },
    {
      title: 'Altersvorsorge',
      titleHref: '/altersvorsorge',
      links: [
        { label: 'Versorgungswerk', href: '/altersvorsorge/versorgungswerk' },
        { label: 'Altersvorsorgedepot', href: '/altersvorsorge/altersvorsorgedepot' },
        { label: 'Private Vorsorge', href: '/altersvorsorge/private-vorsorge' },
        { label: 'Betriebliche AV', href: '/altersvorsorge/betriebliche' },
        { label: 'Basisrente', href: '/altersvorsorge/basis' },
        
      ],
    },
    {
      title: 'Investment',
      titleHref: '/investment',
      links: [
        { label: 'ETFs & Fonds', href: '/investment/etfs-fonds-aktien' },
        { label: 'Immobilien', href: '/investment/immobilien' },
        { label: 'Vermögenswirksame L.', href: '/investment/vl' },
        { label: 'Konten', href: '/investment/konten' },
      ],
    },
    {
      title: 'Pharmakademie',
      titleHref: '/ueber-uns',
      links: [
        { label: 'Über uns', href: '/ueber-uns' },
        { label: 'Beratung', href: '/beratung/individuell' },
        { label: 'Seminare', href: '/beratung/seminare' },
      ],
    },
  ];

  return (
    <footer className="bg-background border-t border-border">
      {/* Main footer content */}
      <div className="mx-auto max-w-[1280px] px-6 md:px-8 lg:px-12 pt-16 pb-10">
        <div className="grid grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr] gap-8 lg:gap-8">
          {/* Brand column */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <img src={logo} alt="Pharmakademie" className="h-14 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-[280px] mb-7">
              Unabhängige Finanzplanung, spezialisiert auf Apotheker & Pharmaziestudierende.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/pharmakademie/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-muted-foreground hover:text-foreground transition-colors duration-200"
              >
                <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/pharmakademie/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-muted-foreground hover:text-foreground transition-colors duration-200"
              >
                <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {columns.map((col) => (
            <div key={col.title}>
              {col.titleHref ? (
                <Link to={col.titleHref} className="text-foreground font-semibold text-sm mb-4 block hover:text-primary transition-colors duration-200">{col.title}</Link>
              ) : (
                <h4 className="text-foreground font-semibold text-sm mb-4">{col.title}</h4>
              )}
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-muted-foreground hover:text-foreground transition-colors duration-200 text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-border">
        <div className="mx-auto max-w-[1280px] px-6 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col gap-1.5">
            <p className="text-muted-foreground text-xs">
              © {currentYear} Pharmakademie. Alle Rechte vorbehalten.
            </p>
            <p className="text-muted-foreground text-[11px] leading-snug max-w-[520px]">
              Aus Gründen der besseren Lesbarkeit wird auf dieser Website das generische Maskulinum verwendet. Sämtliche Personenbezeichnungen gelten gleichermaßen für alle Geschlechter.
            </p>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/datenschutz" className="text-muted-foreground hover:text-foreground text-xs underline underline-offset-2 transition-colors duration-200">
              Datenschutz
            </Link>
            <Link to="/impressum" className="text-muted-foreground hover:text-foreground text-xs underline underline-offset-2 transition-colors duration-200">
              Impressum
            </Link>
            <button
              onClick={() => {
                localStorage.removeItem('cookie-consent');
                window.location.reload();
              }}
              className="text-muted-foreground hover:text-foreground text-xs underline underline-offset-2 transition-colors duration-200"
            >
              Cookie-Einstellungen
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
